import { SearchPropertiesEntity } from '@/types'
import { useRouter } from 'next/router'
import { Spacing, Heading } from '@big-red-group/storefront-common-ui'
import Container from '../Container'
import { Button } from '@big-red-group/storefront-common-ui'
import { ButtonWrap, HeadingWrap, ViewAll, ShowMore } from './SubcategoryBar.styles'
import { useContext, useState } from 'react'
import { getUrlPrefix } from '@/helpers/UrlHelper'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'
import { formatRedirectLinkLabels } from '@/helpers/ThingsToDoHelper'

const SubcategoryBar: React.FC<{
  subcategories?: SearchPropertiesEntity[]
  parentEntityName: string
  selected?: string
  useDefault?: boolean
}> = ({ subcategories, parentEntityName, selected, useDefault }) => {
  const defaultProperties = useContext(DefaultPropertiesContext)
  const router = useRouter()
  const [showAllSubcategories, setShowAllSubcategories] = useState(false)
  if (subcategories === undefined && useDefault) {
    const searchCategories = defaultProperties?.searchProperties?.categories
    if (!searchCategories) {
      return null
    }
    const parentCategory = searchCategories.find((category) => category.name === parentEntityName)
    // If entity is a parent category with zero subcats
    if (parentCategory && !parentCategory.subCategories) {
      return null
    }
    // If entity is a parent category & has subcats
    if (parentCategory && parentCategory.subCategories) {
      subcategories = parentCategory.subCategories
      selected = undefined
    }
    // If entity is a subcategory
    else if (!parentCategory) {
      const parentCategoryList = searchCategories.filter((category) => category.subCategories)
      let parentEntity: any
      parentCategoryList.forEach((parent) => {
        const currentEntity = parent?.subCategories?.find((subcategory) => subcategory.name === parentEntityName)
        if (currentEntity) {
          parentEntity = parent
          return
        }
      })
      subcategories = parentEntity?.subCategories!
      parentEntityName = parentEntity?.name!
    }
  }
  const name = parentEntityName

  const { lang, part1, part2, part3 } = router.query
  const pathname = router.route
  const isThingsToDo = pathname.includes('things-to-do')

  const baseUrl = getUrlPrefix(defaultProperties?.agentConfiguration?.handlerKey)
  let relativeThingsToDoURL = `${baseUrl}/${lang}/things-to-do/${part2}/${part3}`
  relativeThingsToDoURL = relativeThingsToDoURL.replaceAll('/undefined', '')

  let baseButtonUrl = isThingsToDo ? `${baseUrl}/${lang}/things-to-do/${part1}` : `${baseUrl}/${lang}/${part1}/${part2}`
  baseButtonUrl = baseButtonUrl.replaceAll('/undefined', '')

  if (subcategories === undefined || subcategories.length === 0) {
    return null
  }
  return (
    <Container>
      <HeadingWrap>
        <Heading as="h2" size="XL" spacing={false}>
          More {name}
        </Heading>
        {selected && (
          <ViewAll data-testid="view-all" href={`${baseButtonUrl}`}>
            View all{' '}
            {isThingsToDo
              ? formatRedirectLinkLabels(parentEntityName)
              : formatRedirectLinkLabels(part1 + ' ' + parentEntityName)}
          </ViewAll>
        )}
      </HeadingWrap>
      <Spacing size="XL" />
      <ButtonWrap truncated={!showAllSubcategories}>
        {subcategories?.map(({ id, name, urlSegment }) => (
          <Button
            key={id}
            dataTestId={`subcat-${id}`}
            size="S"
            disabled={selected === name}
            onClick={() => router.push(`${baseButtonUrl}/${urlSegment}`)}
          >
            {name}
          </Button>
        ))}
        {!showAllSubcategories && subcategories?.length! > 14 && (
          <ShowMore onClick={() => setShowAllSubcategories(true)}>Show more...</ShowMore>
        )}
      </ButtonWrap>
    </Container>
  )
}

export default SubcategoryBar
